import { DragInDropBody } from "./components/DragInDropBody";
import { DragInDropHeader } from "./components/DragInDropHeader";
import { DragInDropError, DragInDropLoading } from "./components/DragInDropState";
import { Props } from "./DragInDrop.type";

export function DragInDropTable({
    header,
    data,
    actions,
    loading = false,
    error,
    updateOrdenation
}: Props) {
    const tableClasses = [
        'table',
        'table-striped',
        'table-bordered',
        'table-hover',
        `table-lg`,
    ]
        .filter(Boolean)
        .join(' ')

    const visibleColumns = header.filter((col) => col.visible !== false)
    const hasActions = actions && actions.length > 0

    return (
        <div className='card' style={{ position: 'relative' }}>
            {/* Corpo da tabela */}
            <div className='card-body py-3'>
                <div className='table-responsive'>
                    <table className={tableClasses}>
                        <DragInDropHeader
                            columns={visibleColumns}
                        />

                        {loading ? (
                            <DragInDropLoading
                                columns={visibleColumns.length}
                                hasActions={hasActions}
                            />
                        ) : error ? (
                            <DragInDropError
                                message={'Um Erro aconteceu'}
                                columns={visibleColumns.length}
                                hasActions={hasActions}
                            />
                        ) : (
                            <DragInDropBody
                                data={data}
                                columns={visibleColumns}
                                actions={actions}
                                idKey="id" // Nome da propriedade única em cada item (ex: id, _id, uuid)
                                onReorder={(newData) => {
                                    updateOrdenation(newData); // Atualiza o estado local com a nova ordem
                                }}

                            />
                        )}
                    </table>
                </div>
            </div>
        </div>
    )
}